import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { CoreModule } from 'src/app/core/core.module';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { MessagesModule } from 'primeng/messages';
import { InputTextarea } from 'primeng/inputtextarea';
import { GroupsListComponent } from './groups-list/groups-list.component';
import { GroupsDetailComponent } from './groups-detail/groups-detail.component';
import { GroupsRoutingModule } from './groups-routing.module';
import { GroupUserComponent } from './groups-detail/group-user/group-user.component';


@NgModule({ declarations: [
        GroupsListComponent,
        GroupsDetailComponent,
        GroupUserComponent
    ], imports: [CoreModule,
        CommonModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        FormsModule,
        TableModule,
        CardModule,
        TabViewModule,
        CalendarModule,
        MessagesModule,
        GroupsRoutingModule,
        ReactiveFormsModule,
        InputTextModule,
        InputSwitchModule,
        ConfirmDialogModule,
        DropdownModule,
        DynamicDialogModule,
        InputTextarea], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class GroupsModule { }
